import { Container } from "./Container";
import { NavLink } from "./NavLink";
import { getTranslation } from "dictionary";
import { useUserContext } from "context/UserContext";

export function Footer() {
  const { language } = useUserContext();

  return (
    <footer className="bg-slate-50">
      <Container>
        <div className="flex flex-col justify-center items-center py-16">
          <NavLink href="#header">
            <span className="mx-auto font-rochester text-logo px-1 logo font-bold w-auto">
              Simple
            </span>
          </NavLink>

          <nav className="mt-10 text-sm" aria-label="quick links">
            <div className="-my-1 flex flex-wrap justify-start sm:justify-center gap-1 sm:gap-x-6">
              <NavLink href="#primary-features">
                {getTranslation("landingpage", "EXAMPLES", language)}
              </NavLink>
              <NavLink href="#secondary-features">
                {getTranslation("landingpage", "HOW_IT_WORKS", language)}
              </NavLink>
              <NavLink href="#features">
                {getTranslation("landingpage", "FEATURES", language)}
              </NavLink>
              <NavLink href="#faq">
                {getTranslation("landingpage", "FAQ_HEADER", language)}
              </NavLink>
            </div>
          </nav>
        </div>
        <div className="flex flex-col items-center border-t border-slate-400/10 py-10">
          <div className="flex gap-x-4">
            <span className="text-sm ">
              {getTranslation("menu", "SOCIAL_MEDIA", language)}
            </span>
            <a
              href="https://www.facebook.com/simpleapp.shop/"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                // viewBox="0 0 320 512"
                viewBox="0 0 448 512"
                className="h-6 w-6"
              >
                <title>Facebook icon</title>
                <path
                  fill="currentColor"
                  d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
                />
              </svg>
            </a>

            <a
              href="https://www.instagram.com/simpleapp.shop/"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                height="100%"
                viewBox="0 0 24 24"
                width="100%"
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
              >
                <title>Instagram icon</title>

                <path d="M17 2a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5h10m0-2H7a7 7 0 00-7 7v10a7 7 0 007 7h10a7 7 0 007-7V7a7 7 0 00-7-7z"></path>
                <path d="M18.5 7A1.5 1.5 0 1120 5.5 1.5 1.5 0 0118.5 7zM12 8a4 4 0 11-4 4 4 4 0 014-4m0-2a6 6 0 106 6 6 6 0 00-6-6z"></path>
              </svg>
            </a> 
          </div>
        </div>
      </Container>
    </footer>
  );
}
